<template>
  <div class="container">
    <span class="landscape_error" v-show="$store.getters['app/overlays'].show_landscape_error">
      <p id="text_error">Please set device to landscape</p>
    </span>

    <span class="overlay" v-show="$store.getters['app/overlays'].show_start_menu_overlay">
      <img draggable="false" @click="goToHomePage()" id="start_btn" src="./assets/images/Asset 32.png" alt="">
      <img draggable="false" id="quit_btn" src="./assets/images/Asset 31.png" alt="">
      <img draggable="false" id="waterpark_letters" src="./assets/images/Asset 33.png" alt="">
    </span>

    <span class="main_background">
      <video muted="muted" id="video" loop playsinline>
        <source src="./assets/o_background.mp4" type="video/mp4" />
      </video>
    </span>
    
    <router-view/>
  </div>

</template>

<script>

export default {
  name: 'App',

  mounted() {
    document.getElementById('video').play();
    this.checkLandscape()
  },

  created() {
    window.addEventListener("resize", this.checkLandscape);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkLandscape);
  },

  data() {
    return {};
  },

  methods: {
    goToHomePage() {
      this.$router.push('/home');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: false,
          show_start_selector_overlay: true,
      });
    },
    goToStartPage() {
      this.$router.push('/start');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: false,
          show_start_selector_overlay: true,
      });
    },

    // getWindowSize() {
    //   var videoHeight = video.offsetHeight,
    //       videoWidth = video.offsetWidth;

    //     this.$store.dispatch('app/asyncUpdateResolution', {
    //       height: videoHeight,
    //       width: videoWidth,
    //     });
    // }

    checkLandscape() {
      if ( window.innerWidth < ( window.innerHeight * 1.5 ) ) {
        if ( ! this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: true
          });
      } else {
        if ( this.$store.getters['app/overlays'].show_landscape_error )
          this.$store.dispatch('app/asyncUpdateLandscapeOverlay', {
            show_landscape_error: false
          });
      }
    }
  },

  computed: {},

  watch: {}
}
</script>

<style>
  @font-face {
    font-family: "LuckiestGuy";
    src: url('./assets/waterpark/fonts/LuckiestGuy-Regular.ttf') format('truetype');
  }

  /**
  Disable scrolling
  */
  html, body {margin: 0; height: 100%; overflow: hidden}

  .landscape_error {
    background-color: grey;
    width: 105%;
    height: 105%;
    position: absolute;
    z-index: 3;
  }

  #text_error {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 25%;
    color: white;
    width: 95%;
    font-size: 5.5vw;
    text-align: center;
  }

  .container {
    margin: -10px;
  }
  
  .main_background {
    position: absolute;
    z-index: -1;
  }

  body {
    cursor: url('./assets/cursor/material-wood-cursor.png'), default;	
  }

  .clickable:hover {
    opacity: 0.7;
    cursor: url('./assets/cursor/material-wood-pointer.png'), default;
  }

  .swal_html {
    font-family: "LuckiestGuy";
    src: url('./assets/waterpark/fonts/LuckiestGuy-Regular.ttf') format('truetype');
    font-size: 4vw;
    color: #739033;
  }

  .swal2-styled {
    font-family: "LuckiestGuy";
    src: url('./assets/waterpark/fonts/LuckiestGuy-Regular.ttf') format('truetype');
    cursor: url('./assets/cursor/fishing-tool.png'), default;
  }

  /* a:hover {
    cursor: url('./assets/cursor/material-wood-pointer.png'), default;
  } */

  #video {
    width: 100%;
    height: 100%;
  }

  #waterpark_letters {
    position: absolute;
    margin-top: 27%;
    left: 10%;
    width: 50%;
  }

  #start_btn {
    cursor: url('./assets/cursor/material-wood-pointer.png'), default;
    position: absolute;
    margin-top: 36%;
    left: 12%;
    width: 20%;
  }

  #start_btn:hover {
    opacity: 0.7;
  }

  #quit_btn:hover {
    opacity: 0.7;
  }

  #quit_btn {
    cursor: url('./assets/cursor/material-wood-pointer.png'), default;
    position: absolute;
    margin-top: 36%;
    left: 38%;
    width: 20%;
  }

  body {
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }
</style>
